import { useApplicationContext } from "@src/context/ApplicationContext";
import ClientLogsService from "@src/services/client-logs.service";
import logger from "@src/utils/logger";
import { useLocation } from "@uhg-abyss/web/tools/reactRouterTools";
import { useEffect } from "react";

/**
 * Hook that automatically logs page views when a routed component mounts.
 * Should be used in the root layout component (AppBody) to track all page navigations.
 *
 * Logs are sent to the backend via ClientLogsService.logNavigation()
 * Uses component name if available, falls back to route pathname.
 */
export const useNavigationLogging = () => {
  const { data } = useApplicationContext();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    // Guard: Skip if userUuid is not available
    if (!data.userUuid) {
      return;
    }

    // Log page view asynchronously without blocking
    ClientLogsService.logNavigation(data.userUuid, pathname).catch((err) => {
      logger.error({
        text: "Failed to log navigation",
        error: err instanceof Error ? err : undefined,
        location: "useNavigationLogging",
      });
    });
  }, [pathname, data.userUuid]);
};
